module.exports = __webpack_public_path__ + "static/media/dsr_bg6.b899fd30.png";